module.exports = __webpack_public_path__ + "static/media/Step 10-Roles.8a71049f.png";